<div class="container">
  <form *ngIf="itemForm" [formGroup]="itemForm">

    <!-- Header sticky compacto -->
    <div class="header-container">
      <div class="button-container">
        <button mat-raised-button color="accent" type="button" (click)="$event.preventDefault(); close()">
          <mat-icon>arrow_back</mat-icon>
          <ng-container *ngIf="!layoutConf.isMobile">{{ "VOLTAR" | translate }}</ng-container>
        </button>
        <button mat-raised-button color="primary" cdkFocusInitial [matTooltip]="'Salvar Cadastro'" #btnSaveRef="matButton"
          (click)="save(); $event.preventDefault()">
          <mat-icon>save</mat-icon>
          <ng-container *ngIf="!layoutConf.isMobile">{{ "SAVE" | translate }}</ng-container>
        </button>
        <button mat-raised-button color="primary" [matMenuTriggerFor]="menu" aria-label="Mais Opções">
          <mat-icon>more_vert</mat-icon>
          <ng-container *ngIf="!layoutConf.isMobile">Mais Opções</ng-container>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="openEnderecosPopUp(cadastro); $event.preventDefault();">
            <mat-icon>edit_location</mat-icon> Endereços
          </button>
          <button mat-menu-item (click)="openVendedoresPopUp(cadastro); $event.preventDefault();">
            <mat-icon>group</mat-icon> Vendedores/Representantes
          </button>
          <button mat-menu-item (click)="openOcorrenciasPopUp(cadastro); $event.preventDefault();">
            <mat-icon>add_alert</mat-icon> Ocorrências
          </button>
          <button mat-menu-item (click)="openMovtoPopUp(cadastro); $event.preventDefault();">
            <mat-icon>storage</mat-icon> Movimentações
          </button>
          <button mat-menu-item (click)="openAnaliseCreditoPopUp(cadastro); $event.preventDefault();">
            <mat-icon>assessment</mat-icon> Análise de Crédito
          </button>
          <button mat-menu-item (click)="openAnexoUploadListPopUp(cadastro); $event.preventDefault();">
            <mat-icon>attachment</mat-icon> Anexos
          </button>
          <button mat-menu-item *ngIf="jwtAuthService.isAuthorized('ROLE_ROOT')"
            (click)="openWebPopUp(cadastro); $event.preventDefault();">
            <mat-icon>public</mat-icon> Web
          </button>
        </mat-menu>
      </div>
    </div>

    <!-- Conteúdo -->
    <div class="form-content">

      <!-- Dados Básicos -->
      <mat-card class="section-card">
        <mat-card-header><mat-card-title>Cadastro - Dados Básicos</mat-card-title></mat-card-header>
        <mat-card-content>
          <div class="form-grid">

            <mat-form-field appearance="outline" class="col-2">
              <mat-label>Código</mat-label>
              <input matInput type="text" formControlName="codigo" />
              <mat-error *ngIf="itemForm.controls['codigo'].hasError('required') && itemForm.controls['codigo'].touched">Código não informado</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-4">
              <mat-label>Grupo</mat-label>
              <mat-select formControlName="cadCadastroGrupo" (selectionChange)="onSelectionChangeGrupo($event)" required [compareWith]="objectComparisonFunction">
                <mat-option *ngFor="let cadCadastroGrupo of grupos" [value]="cadCadastroGrupo">
                  {{ cadCadastroGrupo.id.toString().padStart(3, '0') + ' - ' + cadCadastroGrupo?.descricao }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="itemForm.controls['cadCadastroGrupo'].hasError('required') && itemForm.controls['cadCadastroGrupo'].touched">Grupo não informado</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-2">
              <mat-label>Data de Cadastro</mat-label>
              <input matInput [value]="cadastro?.issueDate | date:'dd/MM/yyyy'" disabled />
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-2">
              <mat-label>Pessoa</mat-label>
              <mat-select formControlName="pessoa">
                <mat-option value="Juridica">Jurídica</mat-option>
                <mat-option value="Fisica">Física</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-3" *ngIf="itemForm.value.pessoa === 'Juridica'">
              <mat-label>CNPJ</mat-label>
              <input [imask]="maskCnpj" matInput type="text" formControlName="cpfCnpj" />
              <mat-error *ngIf="itemForm.controls['cpfCnpj'].hasError('required') && itemForm.controls['cpfCnpj'].touched">CNPJ é obrigatório</mat-error>
              <mat-error *ngIf="itemForm.controls['cpfCnpj'].hasError('validaCpfCnpj') && itemForm.controls['cpfCnpj'].touched">CNPJ inválido</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-3" *ngIf="itemForm.value.pessoa !== 'Juridica'">
              <mat-label>CPF</mat-label>
              <input [imask]="maskCpf" matInput type="text" formControlName="cpfCnpj" />
              <mat-error *ngIf="itemForm.controls['cpfCnpj'].hasError('required') && itemForm.controls['cpfCnpj'].touched">CPF é obrigatório</mat-error>
              <mat-error *ngIf="itemForm.controls['cpfCnpj'].hasError('validaCpfCnpj') && itemForm.controls['cpfCnpj'].touched">CPF inválido</mat-error>
            </mat-form-field>

            <div class="col-4 consulta-buttons-row" *ngIf="itemForm.value.pessoa === 'Juridica'">
              <button-loading color="primary" type="button" [loading]="isSearchingWs$ | async"
                [loadingText]="('WAITING' | translate) + (counter$ | async) + ' Seg.'"
                (click)="consultaCNPJ(itemForm.controls['cpfCnpj'].value)" [matTooltip]="'Pesquisa CNPJ na Receita WS'">
                <ng-container *ngIf="(counter$ | async) as counter">
                  <ng-container *ngIf="!(counter > 0 && counter < 20)">
                    <mat-icon>search</mat-icon> {{ "SEARCH_CNPJ_WS" | translate }}
                  </ng-container>
                  <ng-container *ngIf="counter > 0 && counter < 20">Aguarde: {{ counter }} Seg.</ng-container>
                </ng-container>
              </button-loading>
              <button-loading color="primary" type="button" *ngIf="itemForm.value.cadMun" [loading]="isSearchingSefaz" [loadingText]="('SEARCHING' | translate)"
                (click)="selecionaUF()" [matTooltip]="'Pesquisa CNPJ na SEFAZ'">
                <mat-icon>search</mat-icon> {{ "SEARCH_CNPJ_SEFAZ" | translate }} ({{ itemForm.value.uf }})
              </button-loading>
            </div>

            <div class="col-6" *ngIf="cnpjReceitaResult || cnpjReceitaResult2">
              <div class="test-result-header compact">
                <div class="test-result-title">Resultado Pesquisa Receita Estadual</div>
                <span class="test-badge" [ngClass]="getConsultaSefazBadgeClass()">
                  <mat-icon>{{ getConsultaSefazBadgeIcon() }}</mat-icon>
                  {{ getConsultaSefazBadgeLabel() }}
                </span>
              </div>
              <div class="test-result-card compact" [ngClass]="getConsultaSefazBadgeClass()">
                <p class="test-result-message compact">{{ getConsultaSefazMessageCompact() }}</p>
              </div>
            </div>

            <mat-form-field appearance="outline" class="col-6">
              <mat-label>Nome/Razão Social</mat-label>
              <input [imask]="maskUpper" matInput type="text" formControlName="razaoSocial" (blur)="preencheNomeFantasia()" />
              <mat-error *ngIf="itemForm.controls['razaoSocial'].hasError('required') && itemForm.controls['razaoSocial'].touched">Nome/Razão Social é obrigatório</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-6">
              <mat-label>Nome Fantasia</mat-label>
              <input [imask]="maskUpper" matInput type="text" formControlName="nomeFantasia" />
              <mat-error *ngIf="itemForm.controls['nomeFantasia'].hasError('required') && itemForm.controls['nomeFantasia'].touched">Nome Fantasia é obrigatório</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-3" *ngIf="!itemForm.value.produtor">
              <mat-label>{{ itemForm.value.pessoa === 'Juridica' ? 'Inscrição Estadual' : 'RG' }}</mat-label>
              <input [imask]="maskUpper" matInput type="text" formControlName="rgInscricao" />
              <mat-error *ngIf="itemForm.controls['rgInscricao'].hasError('required') && itemForm.controls['rgInscricao'].touched">RG/Inscrição é obrigatório</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-2" *ngIf="itemForm.value.produtor">
              <mat-label>{{ itemForm.value.pessoa === 'Juridica' ? 'Inscrição Estadual' : 'RG' }}</mat-label>
              <input [imask]="maskUpper" matInput type="text" formControlName="rgInscricao" />
              <mat-error *ngIf="itemForm.controls['rgInscricao'].hasError('required') && itemForm.controls['rgInscricao'].touched">RG/Inscrição é obrigatório</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-2" *ngIf="itemForm.value.produtor">
              <mat-label>Inscrição CAD-PRO</mat-label>
              <input [imask]="maskUpper" matInput type="text" formControlName="inscricaoCadPro" />
              <mat-error *ngIf="itemForm.controls['inscricaoCadPro'].hasError('required') && itemForm.controls['inscricaoCadPro'].touched">Inscrição CAD-PRO é obrigatória</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-2">
              <mat-label>Contribuinte ICMS</mat-label>
              <mat-select formControlName="contribuinteIcms">
                <mat-option value="Sim">Sim</mat-option>
                <mat-option value="Nao">Não</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-3">
              <mat-label>{{ itemForm.value.pessoa === 'Juridica' ? 'Data da Fundação' : 'Data de Nascimento' }}</mat-label>
              <input matInput [matDatepicker]="picker" formControlName="dataNasc" />
              <mat-hint>DD/MM/YYYY</mat-hint>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker startView="month"></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-3">
              <mat-label>CNH</mat-label>
              <input matInput type="text" formControlName="cnh" />
            </mat-form-field>

            <div class="col-12" *ngIf="itemForm.hasError('atLeastOneId') && (itemForm.controls['cpfCnpj']?.touched || itemForm.controls['rgInscricao']?.touched || itemForm.controls['inscricaoCadPro']?.touched)">
              <mat-error>Informe pelo menos um identificador válido (CPF/CNPJ, RG ou Inscrição CAD-PRO)</mat-error>
            </div>

          </div>
        </mat-card-content>
      </mat-card>

      <!-- Classificação do Cadastro -->
      <mat-card class="section-card">
        <mat-card-header><mat-card-title>Classificação do Cadastro</mat-card-title></mat-card-header>
        <mat-card-content>
          <div class="classificacao-grid">
            <mat-slide-toggle formControlName="cliente">Cliente</mat-slide-toggle>
            <mat-slide-toggle formControlName="fornecedor">Fornecedor</mat-slide-toggle>
            <mat-slide-toggle formControlName="vendedor">Vendedor</mat-slide-toggle>
            <mat-slide-toggle formControlName="produtor">Produtor</mat-slide-toggle>
            <mat-slide-toggle formControlName="funcionario">Funcionário</mat-slide-toggle>
            <mat-slide-toggle formControlName="trabalhador">Trabalhador</mat-slide-toggle>
            <mat-slide-toggle formControlName="transportador">Transportadora</mat-slide-toggle>
            <mat-slide-toggle formControlName="motorista">Motorista</mat-slide-toggle>
            <mat-slide-toggle formControlName="pontoAtendimento">Ponto de Atendimento</mat-slide-toggle>
            <mat-slide-toggle formControlName="orgao">Órgão/Departamento</mat-slide-toggle>
            <mat-slide-toggle formControlName="sindicato">Sindicato</mat-slide-toggle>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Contato -->
      <mat-card class="section-card">
        <mat-card-header><mat-card-title>Contato</mat-card-title></mat-card-header>
        <mat-card-content>
          <div class="form-grid">
            <mat-form-field appearance="outline" class="col-3">
              <mat-label>Telefone Fixo</mat-label>
              <input [imask]="maskFone" matInput type="text" formControlName="telefone1" />
              <mat-hint>Informe DDD + número</mat-hint>
              <mat-error *ngIf="itemForm.controls['telefone1'].hasError('required') && itemForm.controls['telefone1'].touched">Telefone é obrigatório</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-3">
              <mat-label>Celular</mat-label>
              <input [imask]="maskFone" matInput type="text" formControlName="celular" />
              <mat-hint>Informe DDD + número</mat-hint>
              <mat-error *ngIf="itemForm.controls['celular'].hasError('required') && itemForm.controls['celular'].touched">Celular é obrigatório</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-6">
              <mat-label>Email</mat-label>
              <input [imask]="maskEmail" matInput type="email" formControlName="email" />
              <mat-hint>Ex.: usuario@empresa.com</mat-hint>
              <mat-error *ngIf="itemForm.controls['email'].hasError('email') && itemForm.controls['email'].touched">E-mail em formato inválido</mat-error>
              <mat-error *ngIf="itemForm.controls['email'].hasError('required') && itemForm.controls['email'].touched">E-mail é obrigatório</mat-error>
            </mat-form-field>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Análise de Crédito -->
      <mat-card class="section-card">
        <mat-card-header><mat-card-title>Análise de Crédito</mat-card-title></mat-card-header>
        <mat-card-content>
          <div class="form-grid">
            <div class="col-4 d-flex-center">
              <mat-slide-toggle formControlName="chkAnaliseCredito">Checar Análise</mat-slide-toggle>
            </div>
            <mat-form-field appearance="outline" class="col-4">
              <mat-label>Limite de Crédito</mat-label>
              <input matInput type="text" formControlName="limiteCredito" currencyMask
                [options]="{ prefix: '', align: 'right', thousands: '.', decimal: ',', precision: 2, allowNegative: false }" />
            </mat-form-field>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Endereço -->
      <mat-card class="section-card">
        <mat-card-header><mat-card-title>Endereço</mat-card-title></mat-card-header>
        <mat-card-content>
          <div class="form-grid">
            <mat-form-field appearance="outline" class="col-2">
              <mat-label>CEP</mat-label>
              <input [imask]="maskCep" matInput type="text" formControlName="cep" (blur)="consultaCep($event.target.value)" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-4" *ngIf="!(isSearchingCidade$ | async)">
              <mat-label>Cidade</mat-label>
              <mat-select formControlName="cadMun" (selectionChange)="onSelectionChange($event)">
                <mat-option>
                  <ngx-mat-select-search formControlName="searchCidade" placeholderLabel="Pesquisar Cidade"
                    noEntriesFoundLabel="Cidade não encontrada" [searching]="searching"></ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let cadMun of cidades$ | async" [value]="cadMun">
                  {{ cadMun?.municipio?.trim() }} - {{ cadMun?.uf?.trim() }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-5">
              <mat-label>Endereço</mat-label>
              <input [imask]="maskUpper" matInput type="text" formControlName="endereco" />
              <mat-error *ngIf="itemForm.controls['endereco'].hasError('required') && itemForm.controls['endereco'].touched">Endereço é obrigatório</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-1">
              <mat-label>Número</mat-label>
              <input [imask]="maskUpper" matInput type="text" formControlName="numero" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-3">
              <mat-label>Bairro</mat-label>
              <input [imask]="maskUpper" matInput type="text" formControlName="bairro" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-4">
              <mat-label>Complemento</mat-label>
              <input [imask]="maskUpper" matInput type="text" formControlName="complemento" />
            </mat-form-field>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Sócio Administrativo -->
      <mat-card class="section-card" *ngIf="itemForm.value.pessoa === 'Juridica'">
        <mat-card-header><mat-card-title>Sócio Administrativo</mat-card-title></mat-card-header>
        <mat-card-content>
          <div class="form-grid">
            <mat-form-field appearance="outline" class="col-6">
              <mat-label>Sócio Administrativo</mat-label>
              <mat-select formControlName="socioAdm" (selectionChange)="onSelectionChangeSocio($event)">
                <mat-option>
                  <ngx-mat-select-search formControlName="searchSocio" placeholderLabel="Pesquisar Sócio"
                    noEntriesFoundLabel="Sócio não encontrado" [searching]="searching"></ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let s of socios" [value]="s">
                  {{ s?.codigo?.toString()?.padStart(9, '0') + "-" + s?.razaoSocial }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="itemForm.controls['socioAdm'].hasError('required') && itemForm.controls['socioAdm'].touched">Sócio Administrativo é obrigatório</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-6">
              <mat-label>Endereço do Sócio</mat-label>
              <mat-select formControlName="socioAdmEndereco" [compareWith]="objectComparisonFunction">
                <mat-option *ngFor="let e of socioEnderecos" [value]="e">
                  <div class="endereco-option-wrap">
                    <div class="endereco-option-main">{{ e?.endereco?.trim() + ',' + e?.numero?.trim() + '/' + e?.cadMun?.municipio?.trim() + '-' + e?.cadMun?.uf }}</div>
                    <div class="class-tags endereco-option-tags">
                      <span class="tag tag-entrega" *ngIf="e?.entrega">Entrega</span>
                      <span class="tag tag-cobranca" *ngIf="e?.cobranca">Cobrança</span>
                      <span class="tag tag-padrao" *ngIf="e?.padrao">Padrão</span>
                    </div>
                  </div>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Observação -->
      <mat-card class="section-card">
        <mat-card-header><mat-card-title>Observação</mat-card-title></mat-card-header>
        <mat-card-content>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Observação</mat-label>
            <textarea matInput formControlName="obs" rows="3"></textarea>
          </mat-form-field>
        </mat-card-content>
      </mat-card>

      <!-- Resultado de consultas -->
      <mat-card class="section-card" *ngIf="cnpjReceitaResult || cnpjReceitaWsResult">
        <mat-card-header><mat-card-title>Resultado das consultas</mat-card-title></mat-card-header>
        <mat-card-content>
          <div class="test-result-wrap">
            <ng-container *ngIf="cnpjReceitaWsResult">
              <div class="test-result-header">
                <div class="test-result-title">Resultado da pesquisa em Receita WS</div>
                <span class="test-badge" [ngClass]="getConsultaWsBadgeClass()">
                  <mat-icon>{{ getConsultaWsBadgeIcon() }}</mat-icon>
                  {{ getConsultaWsBadgeLabel() }}
                </span>
              </div>
              <div class="test-result-card" [ngClass]="getConsultaWsBadgeClass()">
                <p class="test-result-message">{{ getConsultaWsMessage() }}</p>
                <details class="tech-details">
                  <summary>Detalhes técnicos</summary>
                  <pre>{{ cnpjReceitaWsResult ?? '' | json }}</pre>
                </details>
              </div>
            </ng-container>

            <ng-container *ngIf="cnpjReceitaResult">
              <div class="test-result-header" style="margin-top: 12px;">
                <div class="test-result-title">Resultado da pesquisa na Receita Estadual (SEFAZ)</div>
                <span class="test-badge" [ngClass]="getConsultaSefazBadgeClass()">
                  <mat-icon>{{ getConsultaSefazBadgeIcon() }}</mat-icon>
                  {{ getConsultaSefazBadgeLabel() }}
                </span>
              </div>
              <div class="test-result-card" [ngClass]="getConsultaSefazBadgeClass()">
                <p class="test-result-message">{{ getConsultaSefazMessage() }}</p>
                <details class="tech-details">
                  <summary>Detalhes técnicos</summary>
                  <pre>{{ cnpjReceitaResult ?? '' | json }}</pre>
                </details>
              </div>
            </ng-container>
          </div>
        </mat-card-content>
      </mat-card>

    </div><!-- /form-content -->

  </form>
</div><!-- /container -->